import { Button, KIND, TButtonProps } from "kanopi-components/Button";
import React, { FC, useState } from "react";

import { GenericForwardFlow } from "kw/quoting/components/GenericForwardFlow";
import { Modal } from "kanopi-components/Modal";
import { useAPI } from "kw/api/useAPI";
import { useStyletron } from "baseui";

type TAdminGenericFlowModal = {
  quote: TQuote;
  openModal: (arg: boolean) => void;
  isOpen: boolean;
  onSuccess: () => void;
  modalTitle?: string;
  finalButtonText?: string;
  prefix?: string;
  finishedRoute?: string;
  actionQuery: object;
  questionFlowResponseKey: string;
};

export const AdminGenericModal: FC<TAdminGenericFlowModal> = ({
  quote,
  openModal,
  isOpen,
  onSuccess,
  modalTitle,
  finalButtonText,
  prefix,
  finishedRoute,
  actionQuery,
  questionFlowResponseKey,
}) => {
  const [, theme] = useStyletron();
  const { mutation } = useAPI();
  const adjustQuote = () => {
    mutation(
      {
        admin: {
          priceReferredRiskProfile: [
            {
              riskProfileId: quote?.riskProfile.id,
            },
            {
              id: true,
            },
          ],
        },
      },

      (response: { admin: { priceReferredRiskProfile: { id: number } } }) => {
        // An unsuccessful response will generate an error handled by the API hook
        response?.admin?.priceReferredRiskProfile && onSuccess?.();
      },
      undefined,
      undefined
    );
  };

  const handleSubmit = async () => {
    openModal(false);
    adjustQuote();
  };

  return (
    <Modal onClose={() => openModal(false)} closeable isOpen={isOpen} animate autoFocus>
      <Modal.Header $style={{ textAlign: "center" }}>{modalTitle}</Modal.Header>
      <Modal.Body $style={{ marginTop: theme.sizing.scale800 }}>
        <GenericForwardFlow
          prefix={prefix}
          onComplete={handleSubmit}
          finishedRoute={finishedRoute}
          finalButtonText={finalButtonText}
          questionFlowResponseKey={questionFlowResponseKey}
          actionQuery={actionQuery}
        />
      </Modal.Body>
    </Modal>
  );
};

type TAdminGenericFlowButton = {
  quote: TQuote;
  onSuccess: () => void;
  buttonTitle?: string;
  modalTitle?: string;
  finalButtonText?: string;
  prefix?: string;
  finishedRoute?: string;
  actionQuery: object;
  questionFlowResponseKey: string;
} & TButtonProps;

export const AdminGenericFlowButton: FC<TAdminGenericFlowButton> = ({
  quote,
  onSuccess,
  buttonTitle = "Edit",
  modalTitle,
  finalButtonText,
  prefix,
  finishedRoute,
  actionQuery,
  questionFlowResponseKey,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = (open: boolean) => {
    setIsOpen(open);
  };

  return (
    <>
      <Button
        kind={KIND.secondary}
        outlined={true}
        onClick={() => {
          openModal(true);
        }}
        {...props}
      >
        {buttonTitle}
      </Button>

      {isOpen && (
        <AdminGenericModal
          onSuccess={onSuccess}
          quote={quote}
          openModal={openModal}
          isOpen={isOpen}
          modalTitle={modalTitle}
          finalButtonText={finalButtonText}
          prefix={prefix}
          finishedRoute={finishedRoute}
          actionQuery={actionQuery}
          questionFlowResponseKey={questionFlowResponseKey}
        />
      )}
    </>
  );
};
